<template>
    <div
        v-if="isShowModal"
        class="o-opening-hours-mobilia"
        @click.self="closeModal"
    >
        <OOtgModalContainer @onClose="closeModal">
            <div class="opening-hours-mobilia-container">
                <div
                    v-for="item in $options.OPENING_HOURS"
                    :key="item.id"
                    class="opening-hours-mobilia-container-section"
                >
                    <header class="opening-hours-mobilia-container-header">
                        {{ item.title }}
                    </header>
                    <section class="opening-hours-mobilia-container-wrapper">
                        <span class="section-title">ÖPPETTIDER</span>
                        <span
                            v-for="elem in item.hours"
                            :key="elem.id"
                            class="hours-item-wrapper"
                        >
                            <span class="hours-item">{{ elem.day }}</span>
                            <span class="hours-item">{{ elem.hours }}</span>
                        </span>
                    </section>
                </div>
            </div>
        </OOtgModalContainer>
    </div>
</template>

<script>
import OOtgModalContainer from '../../../organisms/o-otg-modal-container';

import { OPENING_HOURS } from './o-opening-hours-mobilia-constants';
import { EVENTS } from "../../../../utils/constants/bus-events-constants";

export default {
    name: 'OOpeningHoursMobilia',
    components: {
        OOtgModalContainer
    },
    data() {
        return {
            isShowModal: false
        }
    },
    mounted() {
        this.initListeners();
    },
    methods: {
        initModal() {
            this.isShowModal = true;
        },
        closeModal() {
            this.isShowModal = false;
        },
        initListeners() {
            this.$bus.$on(EVENTS.MODALS.OFF_MODAL, this.closeModal);
            this.$bus.$on(EVENTS.MODALS.OPENING_HOURS_INIT, this.initModal);
        },
        removeListeners() {
            this.$bus.$off(EVENTS.MODALS.OFF_MODAL, this.closeModal);
            this.$bus.$off(EVENTS.MODALS.OPENING_HOURS_INIT, this.initModal);
        }
    },
    beforeDestroy() {
        this.removeListeners();
    },
    OPENING_HOURS
}
</script>

<style lang="scss" src="./theme.scss" />